import { render, staticRenderFns } from "./ClassConfig.vue?vue&type=template&id=0c82aa86&"
import script from "./ClassConfig.vue?vue&type=script&lang=js&"
export * from "./ClassConfig.vue?vue&type=script&lang=js&"
import style0 from "./ClassConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports